export default {
    data () {
        return {
            selectedTag: "",

            tagGroupAlways: [{
                label: "Contact Details",
                options: [{
                    label: "Contact Name",
                    value: "##ContactName##"
                }]
            }, {
                label: "Company Details",
                options: [{
                    label: "Company Name",
                    value: "##CompanyTradingName##"
                }, {
                    label: "Phone Number",
                    value: "##CompanyPhone##"
                }, {
                    label: "Email",
                    value: "##CompanyEmail##"
                }, {
                    label: "Maintenance Reporting Link",
                    value: "##MaintenanceRequestLink##"
                }]
            }, {
                label: "User Details",
                options: [{
                    label: "Name",
                    value: "##UserName##"
                }, {
                    label: "Phone",
                    value: "##UserPhone##"
                }, {
                    label: "Mobile",
                    value: "##UserMobile##"
                }, {
                    label: "Default Mailbox Address",
                    value: "##UserSystemEmail##"
                }, {
                    label: "Personal Email Address",
                    value: "##UserPersonalEmail##"
                }]
            }],

            tagGroupProperty: [{
                label: "Property Details",
                options: [{
                    label: "Property Name",
                    value: "##PropertyName##"
                }, {
                    label: "Landlord Full Name",
                    value: "##LandlordFullName##"
                }, {
                    label: "Landlord Contact Name",
                    value: "##LandlordContactName##"
                }, {
                    label: "Email",
                    value: "##LandlordEmail##"
                }, {
                    label: "Landlord Mobile",
                    value: "##LandlordMobile##"
                }]
            }, {
                label: "Tenant Details",
                category: "All",
                options: [{
                    label: "Full Name",
                    value: "##TenantFullName##"
                }, {
                    label: "Contact Name",
                    value: "##TenantContactName##"
                }, {
                    label: "Email",
                    value: "##TenantEmail##"
                }, {
                    label: "Mobile",
                    value: "##TenantMobile##"
                }]
            }],

            tagGroupMaintenance: [{
                label: "Ticket Details",
                options: [{
                    label: "Maintenance Ticket Nr",
                    value: "##TicketRef##"
                }, {
                    label: "Ticket Log Date",
                    value: "##TicketLogDate##"
                }, {
                    label: "Ticket Resolve Date",
                    value: "##TicketResolveDate##"
                }, {
                    label: "Ticket Description",
                    value: "##TicketDescription##"
                }, {
                    label: "Ticket Assignee Name",
                    value: "##AssignedUserName##"
                }, {
                    label: "Ticket Assignee Email",
                    value: "##AssignedUserEmail##"
                }, {
                    label: "Ticket Assignee Mobile",
                    value: "##AssignedUserMobile##"
                }, {
                    label: "Selected Activity",
                    value: "##SelectedActivity##"
                }, {
                    label: "Selected Activity Notes",
                    value: "##SelectedActivityNotes##"
                }, {
                    label: "Last Activity",
                    value: "##LastActivity##"
                }, {
                    label: "Last Activity Notes",
                    value: "##LastActivityNotes##"
                }, {
                    label: "Task Card Instruction",
                    value: "##TaskCardInstruction##"
                }, {
                    label: "Payment Responsibility",
                    value: "##PaymentResponsibility##"
                }, {
                    label: "Contracted Value",
                    value: "##ContractedValue##"
                }, {
                    label: "Issue List (All)",
                    value: "##IssueList##"
                }, {
                    label: "Issue List (Quote)",
                    value: "##IssueList:Quote##"
                }, {
                    label: "Issue List (Observe & Comment)",
                    value: "##IssueList:ObserveAndComment##"
                }, {
                    label: "Issue List (Proceed As Quoted)",
                    value: "##IssueList:ProceedAsQuoted##"
                }, {
                    label: "Issue List (Attend On Call Out)",
                    value: "##IssueList:AttendOnCallOut##"
                }, {
                    label: "Issue List (No Action)",
                    value: "##IssueList:NoAction##"
                }, {
                    label: "Issue List (Completed)",
                    value: "##IssueList:Completed##"
                }]
            }, {
                label: "Service Provider Details",
                options: [{
                    label: "Service Provider",
                    value: "##ServiceProvider##"
                }, {
                    label: "Contact Name",
                    value: "##ServiceProviderContactName##"
                }, {
                    label: "Email",
                    value: "##ServiceProviderEmail##"
                }, {
                    label: "Mobile",
                    value: "##ServiceProviderMobile##"
                }]
            }, {
                label: "Insurance Details",
                options: [{
                    label: "Insurer",
                    value: "##Insurer##"
                }, {
                    label: "Insurance Claim Number",
                    value: "##InsuranceClaimNr##"
                }, {
                    label: "Insurance Notes",
                    value: "##InsuranceNotes##"
                }]
            }],

            tagGroupInspections: [{
                label: "Inspection Details",
                options: [{
                    label: "Inspector Name",
                    value: "##InspectorName##"
                }, {
                    label: "Date",
                    value: "##InspectionDate##"
                }, {
                    label: "Time",
                    value: "##InspectionTime##"
                }, {
                    label: "Type",
                    value: "##InspectionType##"
                }, {
                    label: "Online Inspection Report Link",
                    value: "##OnlineInspectionReportLink##"
                }]
            }],

            tagGroupMaintenanceRequests: [{
                label: "Maintenance Request Details",
                options: [{
                    label: "Reporter Name",
                    value: "##ReporterName##"
                }, {
                    label: "Reported On",
                    value: "##ReportedOn##"
                }, {
                    label: "Maintenance Reporting Link",
                    value: "##MaintenanceRequestLink##"
                }, {
                    label: "Reference Number",
                    value: "##MaintenanceRequestReferenceNumber##"
                }, {
                    label: "Issue List",
                    value: "##MaintenanceRequestIssueList##"
                }]
            }]

        };
    },

    methods: {
        insertAtCaret (insert) {
            const self = this;
            let tArea = this.$refs.savedReplyBodyField.length ? this.$refs.savedReplyBodyField[0] : this.$refs.savedReplyBodyField;

            // filter:
            if (insert === 0) {
                return;
            }
            if (cursorPos === 0) {
                return;
            }

            // get cursor's position:
            let startPos = tArea.selectionStart;
            let endPos = tArea.selectionEnd;
            let cursorPos = startPos;
            let tmpStr = tArea.value;

            // insert:
            self.form.body = tmpStr.substring(0, startPos) + insert + tmpStr.substring(endPos, tmpStr.length);

            // move cursor:
            setTimeout(() => {
                cursorPos += insert.length;
                tArea.selectionStart = tArea.selectionEnd = cursorPos;
            }, 10);

            self.selectedTag = "";
        },

        getAllTagGroups () {
            return [this.tagGroupAlways, this.tagGroupProperty, this.tagGroupMaintenance, this.tagGroupInspections, this.tagGroupMaintenanceRequests];
        },

        getAllTags () {
            return this.getAllTagGroups()
            .flatMap(tagGroup =>
                tagGroup.flatMap(group =>
                    group.options.map(option => option.value)
                ));
        }
    }
};
